import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// ── 全域未處理 Promise Rejection 攔截器 ───────────────────────────
// 用來捕獲 Supabase autoRefreshToken 背景刷新失敗的錯誤
window.addEventListener('unhandledrejection', (event) => {
  const error = event.reason;
  const msg = String(error?.message || error?.error_description || error?.msg || '');
  const isRefreshTokenError =
    msg.includes('invalid_grant') ||
    msg.includes('refresh_token not found') ||
    msg.includes('Refresh Token Not Found') ||
    msg.includes('Invalid Refresh Token') ||
    msg.includes('token has been revoked') ||
    msg.includes('Refresh token not found');

  if (isRefreshTokenError) {
    console.warn('[main] unhandledrejection caught invalid refresh token. Suppressing default handling.');
    event.preventDefault();
  }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)